/* Ruckstuhl Outlet: 1 Shopify inventory unit = 0.10 running metre. */
(function () {
  function init() {
    document.querySelectorAll('[data-outlet-lfm]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var form = box.closest('form');
      if (!form) return;
      var field = box.querySelector('[data-lfm-input]');
      var qty = box.querySelector('[data-lfm-quantity]');
      var prop = box.querySelector('[data-lfm-property]');
      var stock = box.querySelector('[data-lfm-stock]');
      var total = box.querySelector('[data-lfm-total]');
      var compareRow = box.querySelector('[data-lfm-compare-row]');
      var compareTotal = box.querySelector('[data-lfm-compare-total]');
      var error = box.querySelector('[data-lfm-error]');
      var top = box.closest('.product__main, .product, .product__information, .shopify-section') || document;
      var topPrice = top.querySelector('[data-lfm-top-price]') || document.querySelector('[data-lfm-top-price]');
      var variants = JSON.parse(box.dataset.variantInventories || '[]');
      var min = Number(box.dataset.min || 1);
      var step = Number(box.dataset.step || .1);
      var buttons = form.querySelectorAll('[data-add-to-cart-trigger]');
      var currency = document.querySelector('[data-shop-currency]')?.dataset.shopCurrency || 'CHF';
      function money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
          style: 'currency', currency: currency, minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      }
      function variant() {
        var id = form.querySelector('[name="id"]')?.value;
        return variants.find(function (v) { return String(v.id) === String(id); }) || variants[0];
      }
      function update() {
        var v = variant();
        var length = Number(String(field.value).replace(',', '.'));
        var tenths = Math.round(length * 10);
        var max = v && v.managed && v.deny ? v.quantity : 0;
        var exact = Math.abs(tenths / 10 - length) < .00001;
        var valid = Number.isFinite(length) && length >= min - .00001 && step === .1 && exact && tenths > 0 && tenths <= max && Boolean(v && v.managed && v.deny);
        qty.value = valid ? String(tenths) : '0';
        prop.value = valid ? length.toFixed(2) + ' lfm' : '';
        stock.textContent = 'Verfügbar: ' + (max / 10).toFixed(2) + ' lfm';
        total.textContent = v && valid ? money(v.price * tenths) : '–';
        var discounted = Boolean(v && v.compare > v.price);
        if (compareRow) compareRow.hidden = !discounted || !valid;
        if (compareTotal) compareTotal.textContent = discounted && valid ? money(v.compare * tenths) : '';
        if (topPrice && v) {
          var current = topPrice.querySelector('[data-lfm-top-current]');
          var compare = topPrice.querySelector('[data-lfm-top-compare]');
          var discount = topPrice.querySelector('[data-lfm-top-discount]');
          if (current) current.textContent = money(v.price * 10) + ' / lfm';
          if (compare) { compare.hidden = !discounted; compare.textContent = discounted ? money(v.compare * 10) + ' / lfm' : ''; }
          if (discount) { discount.hidden = !discounted; discount.textContent = discounted ? Math.round((v.compare - v.price) * 100 / v.compare) + ' % günstiger' : ''; }
        }
        error.textContent = valid ? '' : (!v || !v.managed || !v.deny ? 'Lagerbestand verfolgen und Überverkauf deaktivieren.' : step !== .1 ? 'Längenschritt muss 0.10 m sein.' : tenths > max ? 'Die gewünschte Länge übersteigt den verfügbaren Rollenbestand.' : 'Bitte eine gültige Länge in 10-cm-Schritten eingeben.');
        buttons.forEach(function (b) { b.disabled = !valid; b.setAttribute('aria-disabled', String(!valid)); });
        return valid;
      }
      field.addEventListener('input', update);
      form.addEventListener('change', function () { setTimeout(update, 0); });
      form.addEventListener('submit', function (e) { if (!update()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
      var variantSelect = form.querySelector('[name="id"]');
      if (variantSelect) {
        new MutationObserver(update).observe(variantSelect, { attributes: true, attributeFilter: ['value'] });
        variantSelect.addEventListener('change', update);
      }
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
